/* Transderma newsletter pop-up.
   Self-contained: injects markup + styles + behavior.
   Triggers once per device on EITHER (a) 50% scroll depth, or (b) exit-intent
   (cursor leaves the viewport from the top). Mobile/touch sessions can't fire
   exit-intent, so they get a 60% scroll trigger plus a generous TIME_FALLBACK
   in case the visitor never scrolls. Dismissal persisted in localStorage.
   To wire to a real provider (Klaviyo, Mailchimp, Shopify customer form),
   replace the handleSubmit fetch with the provider endpoint. */
(function(){
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var KEY            = 'td_np_state';
  var SCROLL_PCT     = 50;     // % of page scrolled before firing
  var SCROLL_PCT_MOB = 60;     // slightly higher on touch (no exit-intent)
  var TIME_FALLBACK  = 90000;  // ms — safety net if visitor never scrolls
  var ARM_DELAY      = 1500;   // ms before triggers arm, so it never flashes on first load

  try { if (localStorage.getItem(KEY)) return; } catch(e){}

  function inject(){
    var style = document.createElement('style');
    style.textContent =
      ".td-np-overlay{position:fixed;inset:0;background:rgba(58,46,34,0.55);display:none;align-items:center;justify-content:center;z-index:9500;padding:20px;opacity:0;transition:opacity .4s ease;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}"+
      ".td-np-overlay.is-open{display:flex;opacity:1}"+
      ".td-np-modal{background:#F7F4EF;max-width:460px;width:100%;padding:48px 40px 36px;box-shadow:0 30px 80px rgba(58,46,34,.35);position:relative;transform:translateY(20px);transition:transform .5s cubic-bezier(0.16,1,0.3,1);font-family:'Jost',sans-serif}"+
      ".td-np-overlay.is-open .td-np-modal{transform:translateY(0)}"+
      ".td-np-close{position:absolute;top:12px;right:12px;background:none;border:none;font-size:24px;color:#7A6852;cursor:pointer;padding:6px;line-height:1;width:36px;height:36px;display:flex;align-items:center;justify-content:center;transition:color .25s}"+
      ".td-np-close:hover{color:#3A2E22}"+
      ".td-np-eyebrow{font-size:12px;letter-spacing:.26em;text-transform:uppercase;color:#7A6852;margin-bottom:14px;font-weight:500}"+
      ".td-np-modal h3{font-family:'Cormorant Garamond','Georgia',serif;font-size:34px;font-weight:300;line-height:1.04;color:#3A2E22;margin:0 0 16px}"+
      ".td-np-modal h3 em{font-style:italic;color:#7A6852}"+
      ".td-np-modal > p{font-size:15px;line-height:1.65;color:#3A2E22;opacity:.82;margin:0 0 24px}"+
      ".td-np-form{display:flex;flex-direction:column;gap:12px;margin:0}"+
      ".td-np-form input{font-family:'Jost',sans-serif;font-size:14px;padding:14px 16px;border:1px solid rgba(122,104,82,.3);background:#EDE8DF;color:#3A2E22;letter-spacing:.02em;-webkit-appearance:none;border-radius:0;width:100%}"+
      ".td-np-form input:focus{outline:none;border-color:#3A2E22}"+
      ".td-np-form button{display:inline-block;font-family:'Jost',sans-serif;font-size:13px;font-weight:500;letter-spacing:.22em;text-transform:uppercase;color:#F7F4EF;background:#3A2E22;padding:16px 28px;text-decoration:none;border:none;cursor:pointer;transition:background .35s,transform .2s}"+
      ".td-np-form button:hover{background:#3A6BB8;transform:translateY(-2px)}"+
      ".td-np-fineprint{font-size:11px;letter-spacing:.04em;color:#7A6852;opacity:.7;margin:16px 0 0;text-align:center;line-height:1.5}"+
      "@media (max-width:480px){.td-np-modal{padding:40px 24px 28px}.td-np-modal h3{font-size:28px}}";
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.className = 'td-np-overlay';
    overlay.setAttribute('aria-hidden','true');
    overlay.innerHTML =
      '<div class="td-np-modal" role="dialog" aria-labelledby="td-np-title" aria-describedby="td-np-desc">'+
        '<button class="td-np-close" type="button" aria-label="Close">×</button>'+
        '<div class="td-np-eyebrow">From Stockholm</div>'+
        '<h3 id="td-np-title">Letters,<br><em>infrequently.</em></h3>'+
        '<p id="td-np-desc">Storage tips, restock notes, and the occasional behind-the-scenes from the lab. Never routine.</p>'+
        '<form class="td-np-form">'+
          '<input type="email" name="email" placeholder="your@email.com" required autocomplete="email">'+
          '<button type="submit">Subscribe</button>'+
        '</form>'+
        '<p class="td-np-fineprint">Unsubscribe anytime. We don\'t share.</p>'+
      '</div>';
    document.body.appendChild(overlay);

    function persist(state){
      try { localStorage.setItem(KEY, state); } catch(e){}
    }
    function close(state){
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
      persist(state || 'dismissed');
    }

    overlay.querySelector('.td-np-close').addEventListener('click', function(){ close('dismissed'); });
    overlay.addEventListener('click', function(e){
      if (e.target === overlay) close('dismissed');
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close('dismissed');
    });

    overlay.querySelector('.td-np-form').addEventListener('submit', function(e){
      e.preventDefault();
      var email = (e.target.email.value || '').trim();
      if (!email) return;

      /* Best-effort submit to Shopify's customer endpoint. Fails silently
         on non-Shopify hosts; in either case we still show the thank-you
         state so the visitor doesn't see an error. */
      try {
        var body = new URLSearchParams();
        body.set('form_type','customer');
        body.set('utf8','✓');
        body.set('contact[tags]','newsletter');
        body.set('contact[email]', email);
        fetch('/contact', { method:'POST', body: body, credentials:'same-origin' }).catch(function(){});
      } catch(e){}
      try { console.log('[Transderma] newsletter signup:', email); } catch(e){}

      var modal = overlay.querySelector('.td-np-modal');
      modal.innerHTML =
        '<button class="td-np-close" type="button" aria-label="Close">×</button>'+
        '<div class="td-np-eyebrow">Done</div>'+
        '<h3>Thank you.</h3>'+
        '<p>You\'re on the list. We\'ll write when there\'s something worth writing.</p>';
      modal.querySelector('.td-np-close').addEventListener('click', function(){ close('subscribed'); });
      setTimeout(function(){ close('subscribed'); }, 3500);
    });

    requestAnimationFrame(function(){
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden','false');
    });
  }

  function start(){
    var fired = false;
    var armed = false;
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    var pctTrigger = isTouch ? SCROLL_PCT_MOB : SCROLL_PCT;

    function fire(){
      if (fired || !armed) return;
      fired = true;
      cleanup();
      inject();
    }

    function onScroll(){
      if (fired || !armed) return;
      var doc = document.documentElement;
      var max = (doc.scrollHeight - window.innerHeight);
      if (max <= 0) return;
      var pct = (window.scrollY / max) * 100;
      if (pct >= pctTrigger) fire();
    }

    function onExitIntent(e){
      if (fired || !armed) return;
      // Cursor leaving the top of the viewport — classic exit-intent signal.
      if (e.clientY <= 0) fire();
    }

    function cleanup(){
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExitIntent);
      if (fallbackTimer) clearTimeout(fallbackTimer);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    if (!isTouch) document.addEventListener('mouseout', onExitIntent);
    var fallbackTimer = setTimeout(fire, TIME_FALLBACK);

    // Arm the triggers after a short delay so a fast first scroll or an
    // accidental cursor jump on page load can never fire the popup.
    setTimeout(function(){ armed = true; onScroll(); }, ARM_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
